const colors = {
  primary: "#1f1f1f",
  primaryHover: "#363636",
  onPrimary: "#fafafa",

  contentAccent: "rgba(0,0,0,0.88)",
  contentSubtle: "rgba(0,0,0,0.74)",
  contentSoft: "rgba(0,0,0,0.55)",

  pageBackground: "#f7f7f7",
  surface: "#ffffff",
  soft: "#fafafa",
  surfaceMuted: "#f3f4f6",

  borderSubtle: "rgba(0,0,0,0.1)",
  borderAccent: "rgba(0,0,0,0.17)",
  divider: "rgba(0,0,0,0.1)",

  radiusLg: "12px",

  stepInactive: "#e0e0e0",
  stepInactiveText: "#465668",

  dicaBg: "#fdf3e3",
  dicaBorder: "#ebc77e",
  dicaText: "#9a6a2e",

  tabSelectedBg: "#e8e8e8",

  textDark: "#263238",
  textMuted: "#455a64",

  error: "#da3333",
};

export default colors;
